module.exports = __webpack_public_path__ + "static/aprendizagem-854d324f9f3d96f95c55a04389dbf425.jpg";